<template>
  <p class="social-links">
    <a v-if="facebookLink" id="social-link-facebook" :href="facebookLink" target="_blank">
      <span class="no-text">Visit Us on Facebook</span>
      <svgicon icon="glyph/24/logo-facebook" width="24" height="24"></svgicon>
    </a>
    <a v-if="twitterLink" id="social-link-twitter" :href="twitterLink" target="_blank">
      <span class="no-text">Visit Us on Twitter</span>
      <svgicon icon="glyph/24/logo-twitter" width="24" height="24"></svgicon>
    </a>
    <a v-if="linkedinLink" id="social-link-linkedin" :href="linkedinLink" target="_blank">
      <span class="no-text">Visit Us on LinkedIn</span>
      <svgicon icon="glyph/24/logo-linkedin" width="24" height="24"></svgicon>
    </a>
    <a v-if="youtubeLink" id="social-link-youtube" :href="youtubeLink" target="_blank">
      <span class="no-text">Visit Us on YouTube</span>
      <svgicon icon="glyph/24/logo-youtube" width="24" height="24"></svgicon>
    </a>
    <a v-if="instagramLink" id="social-link-instagram" :href="instagramLink" target="_blank">
      <span class="no-text">Visit Us on Instagram</span>
      <svgicon icon="glyph/24/logo-instagram" width="24" height="24"></svgicon>
    </a>                
  </p>
</template>

<script>
export default {
  props: {
    facebookLink: String,
    twitterLink: String,
    linkedinLink: String,
    youtubeLink: String,
    instagramLink: String,
  }
}
</script>